import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import EarthEditor from '../views/Earth/Editor/Editor.vue'
import EarthPreview from '../views/Earth/Preview/Preview.vue'
import SceneEditor from '../views/Scene/Editor/Editor.vue'
import ScenePreview from '../views/Scene/Preview/Preview.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/editor',         
        name: 'Editor',
        component: EarthEditor
    },
    {
        path: '/preview',         
        name: 'Preview',
        component: EarthPreview
    },
    {
        path: '/scene/editor',
        name: 'SceneEditor',
        component: SceneEditor
    },
    {
        path: '/scene/preview',
        name: 'ScenePreview',
        component: ScenePreview
    }
]

const router = new VueRouter({
    mode: 'history',
    base: '/3d/',
    routes
})

export default router
